import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { onboardingApi } from '../services/api';

interface OnboardingProps {
  onComplete: (data: { organizationId: string }) => void;
}

export function Onboarding({ onComplete }: OnboardingProps) {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    organizationName: '',
    industry: 'food_beverage',
  });
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);

    try {
      const result = await onboardingApi.complete(form) as any;
      onComplete({ organizationId: result.organization?.id || result.user?.organizationId });
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.detail || 'Failed to complete setup');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
    }}>
      <div className="card" style={{ maxWidth: 500, width: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <img
            src="/favicon/android-chrome-192x192.png"
            alt="SealVision logo"
            width={40}
            height={40}
            style={{ borderRadius: 8, marginBottom: 12 }}
          />
          <h2 style={{ fontSize: '1.3rem', marginBottom: 4 }}>Welcome to SealVision</h2>
          <p className="text-muted text-sm">Let's set up your organization to start monitoring seal quality.</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Organization Name</label>
            <input
              className="form-input"
              value={form.organizationName}
              onChange={(e) => setForm({ ...form, organizationName: e.target.value })}
              placeholder="e.g., Acme Foods GmbH"
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <label className="form-label">Industry</label>
            <select
              className="form-select"
              value={form.industry}
              onChange={(e) => setForm({ ...form, industry: e.target.value })}
            >
              <option value="food_beverage">Food & Beverage</option>
              <option value="pet_food">Pet Food</option>
              <option value="consumer_goods">Consumer Goods</option>
              <option value="other">Other</option>
            </select>
          </div>

          {error && <div className="form-error">{error}</div>}

          <button
            type="submit"
            className="btn btn-primary w-full"
            style={{ justifyContent: 'center', marginTop: 8 }}
            disabled={submitting}
          >
            {submitting ? 'Setting up...' : 'Complete Setup'}
          </button>
        </form>

        <p className="text-sm text-muted text-center" style={{ marginTop: 16 }}>
          You'll be able to add production lines and edge devices after setup.
        </p>
      </div>
    </div>
  );
}
